module.exports = __webpack_public_path__ + "media/images/area-badges/health-wellness-df4e12093f80c7e14f3978ee107fbb40.svg";